define('application/models/ApplicationModel', [

], function() {

    var ApplicationModel = Backbone.Model.extend({
        defaults: {
            namespace: "maz-dior"
        }
    });

    return ApplicationModel;
});
